import { apiService } from '@shared/services/apiServices';

export interface UpdateOfferStatusParams {
  offerId: string;
  isActive: boolean;
}

export interface UpdateOfferStatusResult {
  success: boolean;
  error?: string;
}

/** Map 409 backend messages to user-friendly Polish. */
const STATUS_CONFLICT_MESSAGES: Record<string, string> = {
  'Offer is already active': 'Oferta jest już aktywna.',
  'Offer is already inactive': 'Oferta jest już nieaktywna.',
};

function getErrorMessage(data: unknown): string {
  const raw =
    typeof data === 'string'
      ? data
      : data && typeof data === 'object'
        ? ((data as { error?: string }).error ??
          (data as { message?: string }).message)
        : null;
  if (raw && STATUS_CONFLICT_MESSAGES[raw]) {
    return STATUS_CONFLICT_MESSAGES[raw];
  }
  return raw ?? 'Wystąpił błąd podczas aktualizacji statusu.';
}

export const updateOfferStatusApiService = {
  updateOfferStatus: async (
    params: UpdateOfferStatusParams
  ): Promise<UpdateOfferStatusResult> => {
    const { offerId, isActive } = params;
    const result = await apiService.patchAPI(
      `offer-management/offers/${offerId}/status`,
      { isActive }
    );
    if (result.error) {
      return { success: false, error: getErrorMessage(result.data) };
    }
    return { success: true };
  },
};
